import axios from "axios";
import _ from "lodash";
import Vue from 'vue'
import store from '../index.js.erb'
import PrtfAchievementTypeApiAdminService
    from "../../../components/application/portfolio/Services/Api/Admin/PrtfAchievementType";

const AdminApiAchType = PrtfAchievementTypeApiAdminService;

const AchievementTypeStore = {
    namespaced: true,
    state: ()=>({
        achievementTypes: [],
        payload: {
            name: null,
            group: null
        },
        current_item_tab: "SettingAchievements",
        dialog: false,
        edit_mode_form: false,
        id_type: null,
    }),

    getters: {

    },

    mutations: {
        setCurrentItemTab:(state, tab_item) => state.current_item_tab = tab_item,

        setEditMode: (state, flag) => state.edit_mode_form = flag,

        setEditAchievement: (state, achievement) => {
            state.payload = _.omit(_.cloneDeep(achievement), ['id', 'achievement_kind'])
        },

        setAchievementTypesList: (state, response) => state.achievementTypes = response,

        setIdType: (state, id) => state.id_type = id,

        setDialog: (state, flag) => state.dialog = flag,

        setEditModeForm: (state, flag) => state.edit_mode_form = flag,

        setAchievementName: (state, name) => state.payload.name = name,

        setAchievementGroup: (state, group) => state.payload.group = group,

        resetAchievement: (state) => {
            state.payload = _.mapValues(state.payload, v => v = null)
        },

        unshiftAchievementType: (state, achievementType) => state.achievementTypes.unshift(achievementType),

        updateAchievementTypeData: (state, response) => {
            Vue.set(state.achievementTypes, _.findIndex(state.achievementTypes, {'id' : response.id}), response);
        },

        deleteAchievementType: (state, achievementType) => {
            const idx = _.findIndex(state.achievementTypes, (i) => i.id === achievementType.id)
            state.achievementTypes.splice(idx, 1);
        },
        //
        // toggleHidden: (state, id) => {
        //     const index = _.findIndex(state.achievementTypes, {'id' : id})
        //     Vue.set(state.achievementTypes[index],'is_hidden', !state.achievementTypes[index].is_hidden);
        // },
    },

    actions: {

        async getListAchievementType({ commit }) {
            const response = await AdminApiAchType.index();
            if(_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("setAchievementTypesList", response.data.achievement_types);
            } else {
                store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async createAchievementType({state, commit, dispatch}) {
            const response = await AdminApiAchType.create(state.payload);
            if(_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("unshiftAchievementType", response.data.achievement_type);
                dispatch("setDialogAction", false);
            } else {
                store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async updateAchievementType({state, commit, dispatch}, id) {
            const response = await AdminApiAchType.update(state.id_type, state.payload);
            if(_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("updateAchievementTypeData", response.data.achievement_type);
                dispatch("setDialogAction", false);
            } else {
                store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async deleteAchievementType({state, commit}, id) {
            const response = await AdminApiAchType.delete(id);
            if(_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("deleteAchievementType", response.data.achievement_type);
            } else {
                store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async toggleHiddenAchievementType({state, commit}, id) {
            const response = await AdminApiAchType.toggleHiddenAchievementType(id);
            if(_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("updateAchievementTypeData", response.data.achievement_type);
            } else {
                store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async setDialogAction(context, flag) {
            if (!flag) {
                await context.commit('resetAchievement');
                await context.commit('setEditMode', flag);
                await context.commit('setIdType', null);
            }
            context.commit("setDialog", flag);
        },

    },
}

export default AchievementTypeStore